import React, { useMemo } from "react";
import { AsyncLoader, useAsyncLoader } from "@components/async-loader";
import { cachify } from "@shared/core/cache";
import { afterGateway } from "@shared/apis/gw-helper";
import { getHolidaysByYear as _queryHolidays, getProductCalendar as _getProductCalendar } from "@shared/apis/cprod";

const queryHolidays = cachify(() => afterGateway(_queryHolidays()));
const getProductCalendar = cachify(productId => afterGateway(_getProductCalendar(productId)));

const _require = C => C["default"] || C;

function load({ productId }) {
  return Promise.all([queryHolidays(), getProductCalendar(productId), import("./stock-calendar")]).then(
    ([holidays, productCalendar, StockCalendar]) => ({
      holidays,
      calendar: productCalendar,
      StockCalendar: _require(StockCalendar),
    })
  );
}

export function StockCalendarLoader({ productId, ...props }) {
  const getter = useMemo(() => () => load({ productId }), [Number(productId)]);
  const { loaderProps, value: { holidays, calendar, StockCalendar } = {} } = useAsyncLoader({ getter });
  return (
    <AsyncLoader {...loaderProps}>
      {!StockCalendar || <StockCalendar holidays={holidays} calendar={calendar} {...props} />}
    </AsyncLoader>
  );
}
